import { NavigationModel } from "models/NavigationModel";

import { getLinkTextCosProducts } from "./translations";

export function getProductLinks(): NavigationModel[] {
  return [
    {
      href: "https://cos.sbb.ch",
      text: "Corporate Digital Solutions",
      hintText: "DSO-COS",
      target: "_blank",
      isSelected: false,
    },
    {
      href: "https://rsu.sbb.ch",
      text: "Rapid Solution Unit",
      hintText: "DSO-COS-TRSU",
      target: "_blank",
      isSelected: false,
    },
    {
      href: "https://sbb.sharepoint.com/sites/produkte/SitePages/eGPL-2.aspx",
      text: getLinkTextCosProducts(),
      iconStart: <i className="ms-Icon ms-Icon--ProductCatalog" />,
      isSelected: false,
      target: "_blank",
    },
  ];
}
